import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, gardenCount } from "@/lib/api";

export default function EmailSignup() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [count, setCount] = useState(null);

    const fetchCount = async () => {
        try {
            const { data } = await api.get("/signups/count");
            setCount(data.count);
        } catch (e) {
            /* count is ornamental */
        }
    };

    useEffect(() => {
        fetchCount();
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setSubmitting(true);
        try {
            const { data } = await api.post("/signup", { email: email.trim() });
            if (data.status === "joined") {
                toast.success(data.message);
            } else {
                toast(data.message);
            }
            setEmail("");
            fetchCount();
        } catch (err) {
            toast.error("Something interrupted the remembering. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section id="remembering" data-testid="signup-section" className="relative mx-auto max-w-3xl px-6 py-32 text-center">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1 }}
            >
                <p className="font-cinzel text-xs tracking-[0.4em] text-[#b89860] uppercase">
                    The Garden Gate Is Open
                </p>
                <h2 className="font-cinzel mt-6 text-3xl leading-snug text-[#f3e5ab] sm:text-5xl">
                    Join the Remembering
                </h2>
                <p className="font-cormorant mx-auto mt-5 max-w-xl text-lg italic leading-relaxed text-[#a3b899]">
                    Receive exclusive early chapters, essays from my desk, and a word from
                    the garden the moment the launch draws near.
                </p>

                <form onSubmit={submit} className="mx-auto mt-12 flex max-w-lg flex-col gap-4 sm:flex-row" data-testid="signup-form">
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        data-testid="signup-email-input"
                        className="input-eden font-cormorant flex-1 rounded-sm px-5 py-4 text-lg"
                    />
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="signup-submit-button"
                        className={`btn-eden rounded-sm bg-gradient-to-br from-[rgba(160,120,60,0.9)] to-[rgba(120,85,40,0.9)] px-8 py-4 text-xs text-[#f5e6c8] ${submitting ? "animate-pulse opacity-70" : ""}`}
                    >
                        {submitting ? "Remembering..." : "Join the Remembering"}
                    </button>
                </form>

                <p data-testid="signup-count" className="font-cormorant mt-8 text-base italic text-[#b09a70]">
                    {gardenCount(count ?? 0)} souls have joined the remembering — and more arrive each day.
                </p>
            </motion.div>
        </section>
    );
}
